// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".h-auto[data-v-1676bc68]{height:auto}@media (min-width:1024px){.content-container[data-v-1676bc68]{flex-direction:row}.content-container .right-flex[data-v-1676bc68]{padding-top:.4rem;margin-left:4rem;min-width:41.2rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
